import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  householdMemberRelationshipsSchema,
  householdMemberRelationshipsUpdateSchema,
  householdMemberRelationshipWithMemberSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const householdMemberRelationshipsContract = c.router({
  listHouseholdMemberRelationshipsBetweenMembers: {
    summary:
      "List relationships between a household member and specified relationship members",
    method: "GET",
    path: "/household-member-relationships/between-members",
    query: z.object({
      primaryHouseholdMemberId: z.uuid(),
      relationshipHouseholdMemberIds: z.array(z.uuid()),
    }),
    responses: {
      [HTTPStatusCode.OK]: z.array(householdMemberRelationshipWithMemberSchema),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
  updateHouseholdMemberRelationship: {
    summary: "Update an existing household member relationship by ID",
    method: "PATCH",
    path: "/household-member-relationships/:id",
    pathParams: z.object({
      id: z.uuid(),
    }),
    body: householdMemberRelationshipsUpdateSchema,
    responses: {
      [HTTPStatusCode.OK]: householdMemberRelationshipsSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
    },
  },
  listHouseholdMemberRelationshipsByPrimaryMember: {
    summary: "List all relationships for a given primary household member ID",
    method: "GET",
    path: "/household-member-relationships/by-primary-member",
    responses: {
      [HTTPStatusCode.OK]: z.array(householdMemberRelationshipWithMemberSchema),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
});
